const coutriesData =
{
	chinese: [
		{
			area: "常用国家",
			list: [
				{
					name: "[US]美国",
					value: "US"
				},
				{
					name: "[GB]英国",
					value: "GB"
				},
				{
					name: "[DE]德国",
					value: "DE"
				}, 
				 {
					name: "[FR]法国",
					value: "FR"
				},
				{
					name: "[AU]澳大利亚",
					value: "AU"
				},
				 {
					name: "[CA]加拿大",
					value: "CA"
				}, 
			]
		},
		{
			area: "ABCDE",
			list: [
				{
					name: "[AD]安道尔",
					value: "AD"
				},
				{
					name: "[AE]阿拉伯联合酋长国乌市",
					value: "AE"
				},
				{
					name: "[AF]阿富汗",
					value: "AF"
				},
				{
					name: "[AG]安提瓜及巴布达",
					value: "AG"
				},
				{
					name: "[AI]安圭拉岛",
					value: "AI"
				},
				{
					name: "[AL]阿尔巴尼亚",
					value: "AL"
				},
				{
					name: "[AM]亚美尼亚",
					value: "AM"
				},
				{
					name: "[AN]荷属安的列斯群岛",
					value: "AN"
				},
				{
					name: "[AO]安哥拉",
					value: "AO"
				},
				{
					name: "[AQ]南极洲",
					value: "AQ"
				},
				{
					name: "[AR]阿根廷",
					value: "AR"
				},
				{
					name: "[AS]美属萨摩亚群岛",
					value: "AS"
				},
				{
					name: "[AT]奥地利",
					value: "AT"
				},
				{
					name: "[AU]澳大利亚",
					value: "AU"
				},
				{
					name: "[AW]阿鲁巴岛",
					value: "AW"
				},
				{
					name: "[AX]奥兰群岛",
					value: "AX"
				},
				{
					name: "[AZ]阿塞拜疆",
					value: "AZ"
				},
				{
					name: "[BA]波斯尼亚-黑塞哥维那共和国",
					value: "BA"
				},
				{
					name: "[BB]巴巴多斯",
					value: "BB"
				},
				{
					name: "[BD]孟加拉国",
					value: "BD"
				},
				{
					name: "[BE]比利时",
					value: "BE"
				},
				{
					name: "[BF]布基纳法索",
					value: "BF"
				},
				{
					name: "[BG]保加利亚",
					value: "BG"
				},
				{
					name: "[BH]巴林",
					value: "BH"
				},
				{
					name: "[BI]布隆迪",
					value: "BI"
				},
				{
					name: "[BJ]贝宁",
					value: "BJ"
				},
				{
					name: "[BM]百慕大",
					value: "BM"
				},
				{
					name: "[BN]文莱",
					value: "BN"
				},
				{
					name: "[BO]波利维亚",
					value: "BO"
				},
				{
					name: "[BQ]博奈尔、圣尤斯特歇斯和萨巴",
					value: "BQ"
				},
				{
					name: "[BR]巴西",
					value: "BR"
				},
				{
					name: "[BS]巴哈马",
					value: "BS"
				},
				{
					name: "[BT]不丹",
					value: "BT"
				},
				{
					name: "[BV]布维岛",
					value: "BV"
				},
				{
					name: "[BW]博茨瓦纳",
					value: "BW"
				},
				{
					name: "[BY]白俄罗斯",
					value: "BY"
				},
				{
					name: "[BZ]伯利兹",
					value: "BZ"
				},
				{
					name: "[CA]加拿大",
					value: "CA"
				},
				{
					name: "[CC]科科斯群岛",
					value: "CC"
				},
				{
					name: "[CD]刚果民主共和国",
					value: "CD"
				},
				{
					name: "[CF]中非共和国",
					value: "CF"
				},
				{
					name: "[CG]刚果",
					value: "CG"
				},
				{
					name: "[CH]瑞士",
					value: "CH"
				},
				{
					name: "[CI]科特迪瓦(象牙海岸) ",
					value: "CI"
				},
				{
					name: "[CK]库克群岛 ",
					value: "CK"
				},
				{
					name: "[CL]智利",
					value: "CL"
				},
				{
					name: "[CM]喀麦隆",
					value: "CM"
				},
				{
					name: "[CO]中国",
					value: "CO"
				},
				{
					name: "[CO]哥伦比亚",
					value: "CO"
				},
				{
					name: "[CR]哥斯达黎加",
					value: "CR"
				},
				{
					name: "[CU]古巴",
					value: "CU"
				},
				{
					name: "[CV]佛得角群岛",
					value: "CV"
				},
				{
					name: "[CW]库拉索岛",
					value: "CW"
				},
				{
					name: "[CX]圣诞岛",
					value: "CX"
				},
				{
					name: "[CY]塞浦路斯",
					value: "CY"
				},
				{
					name: "[CZ]捷克",
					value: "CZ"
				},
				{
					name: "[DE]德国",
					value: "DE"
				},
				{
					name: "[DJ]吉布提",
					value: "DJ"
				},
				{
					name: "[DK]丹麦",
					value: "DK"
				},
				{
					name: "[DM]多米尼克",
					value: "DM"
				},
				{
					name: "[DO]多米尼加共和国",
					value: "DO"
				},
				{
					name: "[DZ]阿尔及利亚",
					value: "DZ"
				},
				{
					name: "[EC]厄瓜多尔",
					value: "EC"
				},
				{
					name: "[EE]爱沙尼亚",
					value: "EE"
				},
				{
					name: "[EG]埃及",
					value: "EG"
				},
				{
					name: "[EH]西撒哈拉",
					value: "EH"
				},
				{
					name: "[ER]厄立特里亚",
					value: "ER"
				},
				{
					name: "[ES]西班牙",
					value: "ES"
				},
				{
					name: "[ET]埃塞俄比亚",
					value: "ET"
				}
			]
		},
		{
			area: "FGHIJ",
			list: [
				{
					name: "[FI]芬兰",
					value: "FI"
				},
				{
					name: "[FJ]斐济",
					value: "FJ"
				},
				{
					name: "[FK]福克兰群岛",
					value: "FK"
				},
				{
					name: "[FM]密克罗尼西亚",
					value: "FM"
				},
				{
					name: "[FO]法鲁群岛",
					value: "FO"
				},
				{
					name: "[FR]法国",
					value: "FR"
				},
				{
					name: "[FX]法属美特罗波利坦",
					value: "FX"
				},
				{
					name: "[GA]加蓬",
					value: "GA"
				},
				{
					name: "[GB]英国",
					value: "GB"
				},
				{
					name: "[GD]格林纳达",
					value: "GD"
				},
				{
					name: "[GE]格鲁吉亚",
					value: "GE"
				},
				{
					name: "[GF]法属圭亚那",
					value: "GF"
				},
				{
					name: "[GG]根西岛",
					value: "GG"
				},
				{
					name: "[GH]加纳",
					value: "GH"
				},
				{
					name: "[GI]直布罗陀",
					value: "GI"
				},
				{
					name: "[GL]格陵兰",
					value: "GL"
				},
				{
					name: "[GM]冈比亚",
					value: "GM"
				},
				{
					name: "[GN]几内亚",
					value: "GN"
				},
				{
					name: "[GP]瓜德罗普",
					value: "GP"
				},
				{
					name: "[GQ]赤道几内亚",
					value: "GQ"
				},
				{
					name: "[GR]希腊",
					value: "GR"
				},
				{
					name: "[GS]南乔治亚岛和南桑威奇群岛",
					value: "GS"
				},
				{
					name: "[GT]危地马拉",
					value: "GT"
				},
				{
					name: "[GU]关岛",
					value: "GU"
				},
				{
					name: "[GW]几内亚比绍",
					value: "GW"
				},
				{
					name: "[GY]圭亚那",
					value: "GY"
				},
				{
					name: "[HK]中国香港",
					value: "HK"
				},
				{
					name: "[HM]赫德岛和麦克唐纳岛",
					value: "HM"
				},
				{
					name: "[HN]洪都拉斯",
					value: "HN"
				},
				{
					name: "[HR]克罗地亚",
					value: "HR"
				},
				{
					name: "[HT]海地",
					value: "HT"
				},
				{
					name: "[HU]匈牙利",
					value: "HU"
				},
				{
					name: "[IC]加那利群岛",
					value: "IC"
				},
				{
					name: "[ID]印度尼西亚",
					value: "ID"
				},
				{
					name: "[IE]爱尔兰",
					value: "IE"
				},
				{
					name: "[IL]以色列",
					value: "IL"
				},
				{
					name: "[IM]马恩岛",
					value: "IM"
				},
				{
					name: "[IN]印度",
					value: "IN"
				},
				{
					name: "[IO]英属印度洋地区(查各群岛)",
					value: "IO"
				},
				{
					name: "[IQ]伊拉克",
					value: "IQ"
				},
				{
					name: "[IR]伊朗",
					value: "IR"
				},
				{
					name: "[IS]冰岛",
					value: "IS"
				},
				{
					name: "[IT]意大利",
					value: "IT"
				},
				{
					name: "[JE]泽西岛(英属)",
					value: "JE"
				},
				{
					name: "[JM]牙买加",
					value: "JM"
				},
				{
					name: "[JO]约旦",
					value: "JO"
				},
				{
					name: "[JP]日本",
					value: "JP"
				},
				{
					name: "[JU]南斯拉夫",
					value: "JU"
				}
			]
		},
		{
			area: "KLMNO",
			list: [
				{
					name: "[KE]肯尼亚",
					value: "KE"
				},
				{
					name: "[KG]吉尔吉斯斯坦",
					value: "KG"
				},
				{
					name: "[KH]柬埔寨",
					value: "KH"
				},
				{
					name: "[KI]基利巴斯共和国",
					value: "KI"
				},
				{
					name: "[KM]科摩罗",
					value: "KM"
				},
				{
					name: "[KN]圣基茨",
					value: "KN"
				},
				{
					name: "[KP]朝鲜",
					value: "KP"
				},
				{
					name: "[KR]韩国",
					value: "KR"
				},
				{
					name: "[KW]科威特",
					value: "KW"
				},
				{
					name: "[KY]开曼群岛",
					value: "KY"
				},
				{
					name: "[KZ]哈萨克斯坦",
					value: "KZ"
				},
				{
					name: "[LA]老挝",
					value: "LA"
				},
				{
					name: "[LB]黎巴嫩",
					value: "LB"
				},
				{
					name: "[LC]圣卢西亚",
					value: "LC"
				},
				{
					name: "[LI]列支敦士登",
					value: "LI"
				},
				{
					name: "[LK]斯里兰卡",
					value: "LK"
				},
				{
					name: "[LR]利比里亚",
					value: "LR"
				},
				{
					name: "[LS]莱索托",
					value: "LS"
				},
				{
					name: "[LT]立陶宛",
					value: "LT"
				},
				{
					name: "[LU]卢森堡",
					value: "LU"
				},
				{
					name: "[LV]拉脱维亚",
					value: "LV"
				},
				{
					name: "[LY]利比亚",
					value: "LY"
				},
				{
					name: "[MA]摩洛哥",
					value: "MA"
				},
				{
					name: "[MC]摩纳哥",
					value: "MC"
				},
				{
					name: "[MD]摩尔多瓦",
					value: "MD"
				},
				{
					name: "[ME]黑山共和国",
					value: "ME"
				},
				{
					name: "[MG]马达加斯加",
					value: "MG"
				},
				{
					name: "[MH]马绍尔群岛",
					value: "MH"
				},
				{
					name: "[MK]马其顿",
					value: "MK"
				},
				{
					name: "[ML]马里",
					value: "ML"
				},
				{
					name: "[MM]缅甸",
					value: "MM"
				},
				{
					name: "[MN]蒙古",
					value: "MN"
				},
				{
					name: "[MO]中国澳门",
					value: "MO"
				},
				{
					name: "[MP]塞班岛",
					value: "MP"
				},
				{
					name: "[MQ]马提尼克",
					value: "MQ"
				},
				{
					name: "[MR]毛里塔尼亚",
					value: "MR"
				},
				{
					name: "[MS]蒙特塞拉特岛",
					value: "MS"
				},
				{
					name: "[MT]马耳他",
					value: "MT"
				},
				{
					name: "[MU]毛里求斯",
					value: "MU"
				},
				{
					name: "[MV]马尔代夫",
					value: "MV"
				},
				{
					name: "[MW]马拉维",
					value: "MW"
				},
				{
					name: "[MX]墨西哥",
					value: "MX"
				},
				{
					name: "[MY]马来西亚",
					value: "MY"
				},
				{
					name: "[MZ]莫桑比克",
					value: "MZ"
				},
				{
					name: "[NA]纳米比亚",
					value: "NA"
				},
				{
					name: "[NC]新喀里多尼亚",
					value: "NC"
				},
				{
					name: "[NE]尼日尔",
					value: "NE"
				},
				{
					name: "[NF]诺褔克岛",
					value: "NF"
				},
				{
					name: "[NG]尼日利亚",
					value: "NG"
				},
				{
					name: "[NI]尼加拉瓜",
					value: "NI"
				},
				{
					name: "[NL]荷兰",
					value: "NL"
				},
				{
					name: "[NO]挪威",
					value: "NO"
				},
				{
					name: "[NP]尼泊尔",
					value: "NP"
				},
				{
					name: "[NR]瑙鲁共和国",
					value: "NR"
				},
				{
					name: "[NU]纽埃岛",
					value: "NU"
				},
				{
					name: "[NZ]新西兰",
					value: "NZ"
				},
				{
					name: "[OM]阿曼",
					value: "OM"
				}
			]
		},
		{
			area: "PQRST",
			list: [
				{
					name: "[PA]巴拿马",
					value: "PA"
				},
				{
					name: "[PE]秘鲁",
					value: "PE"
				},
				{
					name: "[PF]塔希堤",
					value: "PF"
				},
				{
					name: "[PG]巴布亚新几内亚",
					value: "PG"
				},
				{
					name: "[PH]菲律宾",
					value: "PH"
				},
				{
					name: "[PK]巴基斯坦",
					value: "PK"
				},
				{
					name: "[PL]波兰",
					value: "PL"
				},
				{
					name: "[PM]圣皮埃尔和密克隆群岛",
					value: "PM"
				},
				{
					name: "[PN]皮特凯恩群岛",
					value: "PN"
				},
				{
					name: "[PR]波多黎各",
					value: "PR"
				},
				{
					name: "[PS]巴勒斯坦",
					value: "PS"
				},
				{
					name: "[PT]葡萄牙",
					value: "PT"
				},
				{
					name: "[PW]帕劳",
					value: "PW"
				},
				{
					name: "[PY]巴拉圭",
					value: "PY"
				},
				{
					name: "[QA]卡塔尔",
					value: "QA"
				},
				{
					name: "[RE]留尼汪岛",
					value: "RE"
				},
				{
					name: "[RM]124",
					value: "RM"
				},
				{
					name: "[RO]罗马尼",
					value: "RO"
				},
				{
					name: "[RS]塞尔维亚",
					value: "RS"
				},
				{
					name: "[RU]俄罗斯",
					value: "RU"
				},
				{
					name: "[RV]124",
					value: "RV"
				},
				{
					name: "[RW]卢旺达",
					value: "RW"
				},
				{
					name: "[SA]沙特阿拉伯",
					value: "SA"
				},
				{
					name: "[SB]所罗门群岛",
					value: "SB"
				},
				{
					name: "[SC]塞舌尔",
					value: "SC"
				},
				{
					name: "[SD]苏丹",
					value: "SD"
				},
				{
					name: "[SE]瑞典",
					value: "SE"
				},
				{
					name: "[SG]新加坡",
					value: "SG"
				},
				{
					name: "[SH]圣赫勒拿岛",
					value: "SH"
				},
				{
					name: "[SI]斯洛文尼亚",
					value: "SI"
				},
				{
					name: "[SJ]斯瓦尔巴岛和扬马延岛",
					value: "SJ"
				},
				{
					name: "[SK]斯洛伐克",
					value: "SK"
				},
				{
					name: "[SL]塞拉利昂",
					value: "SL"
				},
				{
					name: "[SM]圣马力诺",
					value: "SM"
				},
				{
					name: "[SN]塞内加尔",
					value: "SN"
				},
				{
					name: "[SO]索马里",
					value: "SO"
				},
				{
					name: "[SR]苏里南",
					value: "SR"
				},
				{
					name: "[SS]南苏丹共和国",
					value: "SS"
				},
				{
					name: "[ST]圣多美和普林西比",
					value: "ST"
				},
				{
					name: "[SV]萨尔瓦多",
					value: "SV"
				},
				{
					name: "[SX]荷属圣马丁",
					value: "SX"
				},
				{
					name: "[SY]叙利亚",
					value: "SY"
				},
				{
					name: "[SZ]斯威士兰",
					value: "SZ"
				},
				{
					name: "[TA]特里斯坦",
					value: "TA"
				},
				{
					name: "[TC]特克斯和凯科斯群岛",
					value: "TC"
				},
				{
					name: "[TD]乍得",
					value: "TD"
				},
				{
					name: "[TF]法属南部领土",
					value: "TF"
				},
				{
					name: "[TG]多哥",
					value: "TG"
				},
				{
					name: "[TH]泰国",
					value: "TH"
				},
				{
					name: "[TJ]塔吉克斯坦",
					value: "TJ"
				},
				{
					name: "[TK]托克劳",
					value: "TK"
				},
				{
					name: "[TL]东帝汶",
					value: "TL"
				},
				{
					name: "[TM]土库曼斯坦",
					value: "TM"
				},
				{
					name: "[TN]突尼斯",
					value: "TN"
				},
				{
					name: "[TO]汤加",
					value: "TO"
				},
				{
					name: "[TR]土耳其",
					value: "TR"
				},
				{
					name: "[TT]特立尼达和多巴哥",
					value: "TT"
				},
				{
					name: "[TV]图瓦卢",
					value: "TV"
				},
				{
					name: "[TW]中国台湾",
					value: "TW"
				},
				{
					name: "[TZ]坦桑尼亚",
					value: "TZ"
				}
			]
		},
		{
			area: "UVWXYZ",
			list: [
				{
					name: "[UA]乌克兰",
					value: "UA"
				},
				{
					name: "[UG]乌干达",
					value: "UG"
				},
				{
					name: "[UM]美国本土外小岛屿",
					value: "UM"
				},
				{
					name: "[US]美国",
					value: "US"
				},
				{
					name: "[UY]乌拉圭",
					value: "UY"
				},
				{
					name: "[UZ]乌兹别克斯坦",
					value: "UZ"
				},
				{
					name: "[VA]梵蒂冈",
					value: "VA"
				},
				{
					name: "[VC]圣文森特和格林纳丁斯岛",
					value: "VC"
				},
				{
					name: "[VE]委内瑞拉",
					value: "VE"
				},
				{
					name: "[VG]英属维尔京群岛",
					value: "VG"
				},
				{
					name: "[VI]美属维尔京群岛",
					value: "VI"
				},
				{
					name: "[VN]越南",
					value: "VN"
				},
				{
					name: "[VU]瓦努阿图",
					value: "VU"
				},
				{
					name: "[VV]不列颠帝国",
					value: "VV"
				},
				{
					name: "[WF]瓦利斯群岛和富图纳群岛",
					value: "WF"
				},
				{
					name: "[WS]西萨摩亚",
					value: "WS"
				},
				{
					name: "[XB]伯奈尔岛",
					value: "XB"
				},
				{
					name: "[XC]库拉索岛(荷兰)",
					value: "XC"
				},
				{
					name: "[XD]阿森松",
					value: "XD"
				},
				{
					name: "[XE]圣尤斯塔提马斯岛",
					value: "XE"
				},
				{
					name: "[XG]北非西班牙属土",
					value: "XG"
				},
				{
					name: "[XH]亚速尔群岛",
					value: "XH"
				},
				{
					name: "[XI]马德拉岛",
					value: "XI"
				},
				{
					name: "[XJ]巴利阿里群岛",
					value: "XJ"
				},
				{
					name: "[XK]科索沃",
					value: "XK"
				},
				{
					name: "[XM]圣马腾岛",
					value: "XM"
				},
				{
					name: "[XN]尼维斯岛",
					value: "XN"
				},
				{
					name: "[XS]索马里兰",
					value: "XS"
				},
				{
					name: "[XY]圣巴特勒米岛",
					value: "XY"
				},
				{
					name: "[YE]也门阿拉伯共合国",
					value: "YE"
				},
				{
					name: "[YT]马约特",
					value: "YT"
				},
				{
					name: "[ZA]南非",
					value: "ZA"
				},
				{
					name: "[ZM]赞比亚",
					value: "ZM"
				},
				{
					name: "[ZR]扎伊尔",
					value: "ZR"
				},
				{
					name: "[ZW]津巴布韦",
					value: "ZW"
				}
			]
		}
	]
}
export default coutriesData;


// WEBPACK FOOTER //
// ./public/assets/js/country.js